import { render } from "./Endereco.vue?vue&type=template&id=24af0ad7"
import script from "./Endereco.vue?vue&type=script&lang=js"
export * from "./Endereco.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__